module.exports = "/assets/xmas-decorator.png?uiEHmfO";